module.exports = __webpack_public_path__ + "static/media/1.15.586b84d8.png";